import NewSiteProductListSection from './NewSiteProductListSection'

export default NewSiteProductListSection
